import {
    SkyNetQueryLoaderParams,
} from 'app/requests/skyNetQueryLoader/skyNetQueryLoader'
import {
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    PersistentKeys,
    registerPersistentKey,
} from 'app/enums/persistentKeys'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    RateCardsTabs,
} from 'app/enums/domain.enums'
import {
    SkyDataGridColumnDefinition,
} from 'app/shared-components/SkyBaseDataGrid'
import {
    SkyNetObjectConfigParams,
} from 'app/shared-components/SkyNetObjectProfile'
import aPricingRateCardRequests from 'app/requests/APricingRateCard/APricingRateCard.requests'
import {
    RateCardStatus,
} from 'app/enums/label.enums'
import {
    APricingRateCardFilterRequestResponse,
} from 'app/requests/APricingRateCard/APricingRateCard.types'
import {
    RequestConfigFunction,
} from 'app/types/request.types'
import ARateCardUpdate from './ARateCardUpdate'
import ARateCardCreate from './ARateCardCreate'
import StandardBaseLease from './StandardBaseLease'
import StandardAdditionalFees from './StandardAdditionalFees'

const columns: SkyDataGridColumnDefinition<APricingRateCardFilterRequestResponse>[] = [
    {
        name: 'number',
        reduced: true,
        labelKey: 'RATE_CARD_NUMBER',
    },
    {
        name: 'accountName',
        reduced: true,
        labelKey: 'ACCOUNT',
    },
    {
        name: 'status',
        componentName: 'EnumValue',
        allowedValuesEnum: RateCardStatus,
        labelKey: 'STATUS',
    },
    {
        name: 'validFrom',
        componentName: 'DateTimeCell',
        labelKey: 'VALID_FROM',
    },
    {
        name: 'validTo',
        componentName: 'DateTimeCell',
        labelKey: 'VALID_TO',
    },
    {
        name: 'changedOn',
        componentName: 'DateTimeCell',
        labelKey: 'CHANGED_ON',
    },
    {
        name: 'changedBy',
        labelKey: 'CHANGED_BY',
    },
]

const skyNetQueryLoaderConfig = {
    requestConfigFunction:
        aPricingRateCardRequests.getById as RequestConfigFunction,
    requestKey: RequestKeys.getAPricingRateCardById,
} as SkyNetQueryLoaderParams

export const formViews: SidebarTab[] = [
    {
        label: 'RATE_CARD',
        url: RateCardsTabs.RateCard,
        Component: ARateCardUpdate,
        skyNetQueryLoaderConfig,
    },
    {
        label: 'STANDARD_BASE_LEASE',
        url: RateCardsTabs.BaseLease,
        skyNetQueryLoaderConfig,
        Component: StandardBaseLease,
    },
    {
        label: 'STANDARD_ADDITIONAL_FEES',
        url: RateCardsTabs.AdditionalFees,
        skyNetQueryLoaderConfig,
        Component: StandardAdditionalFees,
    },
]

const ARateCardsConfig: SkyNetObjectConfigParams<APricingRateCardFilterRequestResponse> = {
    persistentKey: registerPersistentKey(PersistentKeys.ARateCardsTable),
    formViews,
    columns,
    uniqField: 'id',
    config: [{
        url: CommonRoutes.All,
        name: 'ALL_VERSIONS',
        requestKey: RequestKeys.getAPricingRateCardFilterRequest,
        request: aPricingRateCardRequests.filterRequest(),
    }],
    actionComponents: {
        Create: {
            component: ARateCardCreate,
            accessOnly: ['a_pricing_rates_create'],
        },
    },
}

export default ARateCardsConfig
